import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { useAuthContext, useRefresh } from '../../context/auth.context'
import { useLoad } from '../../shared/hooks/load'
import { useApiListNodeOrg } from '../../api-new/state/content'
import { pathNodeContent } from '../../layout/authorized/org/node/common/shared/path-node-content'
import { pathNodeTemplate } from '../../layout/authorized/org/node/common/shared/path-node-template'
import { useParamsInt } from '../../shared/hooks/location'
import { AlertError } from '../../shared/alert/alert-error'
import { PageTrail } from '../../shared/sso-workspace/page-trail'
import { SECTION } from '../../shared/navigation/sections'
import { RecordNotFound, notFoundText } from '../../shared/page/record-view'

export const RedirectCourseDetails = () => {
  const history = useHistory()
  const { refreshToken } = useParams()
  const { nodeID } = useParamsInt()

  const [error, updateError] = useState()
  // Signed in, and the node isn't one this organization can open here (not
  // in its list, or not a course, folder or template): the page says so
  // under Content instead of staying blank (audit F23).
  const [missing, updateMissing] = useState(false)

  const authContext = useAuthContext()
  const { refreshRecreate } = useRefresh()

  const apiListNodeOrg = useApiListNodeOrg()

  const redirect = async () => {
    if (authContext.state.isAuth) {
      let nodes = await apiListNodeOrg.get()

      let node = nodes.find(i => i.id === nodeID)

      if (node && node.metadata) {
        let data = JSON.parse(node.metadata)

        if (data.DataType === 'CATEGORY' || data.DataType === 'COURSE') {
          let path = pathNodeContent(nodes, nodeID)
          history.replace(`${path}`)
          return
        }

        if (data.DataType === 'COURSE_TEMPLATE') {
          let path = pathNodeTemplate(nodes, nodeID)
          history.replace(`${path}`)
          return
        }
      }
      updateMissing(true)
    } else if (refreshToken) {
      await refreshRecreate(refreshToken)
    } else {
      history.replace(`/auth/email?redirect=/redirect/content-details/${nodeID}`)
    }
  }

  useLoad(async () => {
    try {
      await redirect()
    } catch (e) {
      updateError(e)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (missing) {
    return (
      <React.Fragment>
        <PageTrail trail={[SECTION.content, { url: `/redirect/course-details/${nodeID}`, text: notFoundText('course') }]} />
        <RecordNotFound noun="course" back={{ label: `Go to ${SECTION.content.text}`, to: SECTION.content.url }} />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <AlertError error={error} />
      <p className="sw-hint p-3" role="status">Opening the course…</p>
    </React.Fragment>
  )
}
